"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrBoosters = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const components_common_meta_modules_1 = require("@hotelplan/components.common.meta-modules");
const libs_polyfills_1 = require("@hotelplan/libs.polyfills");
const fdr_boosters_styles_1 = require("./fdr-boosters.styles");
const DEFAULT_TIMES_TO_REPEAT = 2;
const MS_IN_SECOND = 1000;
const CLOSED_BOOSTERS_FLAG_VALUE = 'true';
function areBoostersClosedOnce() {
    return !!js_cookie_1.default.get(components_common_meta_modules_1.BOOSTERS_CLOSED_COOKIE_NAME);
}
function FdrBoosters({ boosters, timesToRepeat = DEFAULT_TIMES_TO_REPEAT, className, }) {
    var _a;
    const [t] = (0, next_i18next_1.useTranslation)('common');
    const { hideBoosters } = (0, components_common_meta_modules_1.useMetaModulesContext)();
    const [boostersOnceClosed, setBoostersOnceClosed] = (0, react_1.useState)(hideBoosters);
    // NOTE: We need to repeat boosters TIMES_TO_REPEAT times.
    const boostersToShow = (0, react_1.useMemo)(() => {
        return [].concat(...Array(timesToRepeat).fill(boosters));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [boosters]);
    const [currentBoosterId, setCurrentBoosterId] = (0, react_1.useState)(boostersOnceClosed ? undefined : (_a = boostersToShow[0]) === null || _a === void 0 ? void 0 : _a.id);
    (0, react_1.useEffect)(() => {
        var _a;
        if (boostersOnceClosed)
            return;
        setCurrentBoosterId((_a = boostersToShow[0]) === null || _a === void 0 ? void 0 : _a.id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [boostersToShow]);
    const timerIDsRef = (0, react_1.useRef)([]);
    const startTimersRef = (0, react_1.useRef)((boostersList) => {
        let durationToWait = 0;
        let showBoosterIndefinitely = false;
        boostersList.map(({ duration }, index) => {
            // NOTE: If the zero duration was found or there is only one booster, then other boosters should not be shown
            // and the booster with 0 duration should stay indefinitely.
            if (!duration || boosters.length === 1) {
                showBoosterIndefinitely = true;
            }
            durationToWait += duration ? duration * MS_IN_SECOND : 0;
            if (!showBoosterIndefinitely) {
                const boosterTimer = setTimeout((() => {
                    if (areBoostersClosedOnce())
                        return;
                    // NOTE: After timeout set the next booster.
                    setCurrentBoosterId(boostersToShow[index + 1]
                        ? boostersToShow[index + 1].id
                        : undefined);
                }), durationToWait);
                timerIDsRef.current.push(boosterTimer);
            }
        });
    });
    (0, react_1.useEffect)(() => {
        if (!currentBoosterId || boostersOnceClosed)
            return;
        function onLoad() {
            startTimersRef.current(boostersToShow);
        }
        function clearTimeouts() {
            timerIDsRef.current.map(timerID => clearTimeout(timerID));
            timerIDsRef.current = [];
        }
        if (document.readyState === 'complete') {
            const requestId = window.requestAnimationFrame(onLoad);
            return function () {
                clearTimeouts();
                window.cancelAnimationFrame(requestId);
            };
        }
        window.addEventListener('load', onLoad, libs_polyfills_1.optionsWithPassive);
        return () => {
            clearTimeouts();
            window.removeEventListener('load', onLoad);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [boosters]);
    function onCloseHandler() {
        js_cookie_1.default.set(components_common_meta_modules_1.BOOSTERS_CLOSED_COOKIE_NAME, CLOSED_BOOSTERS_FLAG_VALUE);
        setBoostersOnceClosed(true);
        (0, components_common_meta_modules_1.setBrowserMetaModulesContext)(Object.assign(Object.assign({}, (0, components_common_meta_modules_1.getBrowserMetaModulesContext)()), { hideBoosters: true }));
        setCurrentBoosterId(undefined);
    }
    if (boostersOnceClosed)
        return null;
    return (react_1.default.createElement(fdr_boosters_styles_1.FdrBoostersList, { "data-id": "fdr-booster-list", className: className }, boosters === null || boosters === void 0 ? void 0 : boosters.map((booster, index) => {
        if (currentBoosterId !== booster.id)
            return;
        return (react_1.default.createElement(fdr_boosters_styles_1.FdrBoosterWrapper, { key: index, "data-id": `fdr-booster-${booster.id}`, className: "booster-wrapper" },
            react_1.default.createElement("div", { className: "booster-text", dangerouslySetInnerHTML: { __html: booster.mainText } }),
            react_1.default.createElement(fdr_boosters_styles_1.FdrBoosterCloseButton, { variant: "iconBtn", onClick: onCloseHandler, icon: {
                    name: 'close',
                } }, t('common:close'))));
    })));
}
exports.FdrBoosters = FdrBoosters;
//# sourceMappingURL=fdr-boosters.js.map